import selectLocalExercise from './selectLocalExercise';
const selectCurrentChoice = (state, exerciseId) => {
  const localExercise = selectLocalExercise(state, exerciseId);
  if (localExercise === undefined) {
    return undefined;
  }
  return localExercise.currentChoice;
};
export default selectCurrentChoice;